import {CDN_URL} from "./api";

const getCdnImage = (url, extension)=>{
	return CDN_URL + url + extension;
}

export default getCdnImage;
